import { render } from "./CookieBanner.vue?vue&type=template&id=121414e4&scoped=true"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"

import "./CookieBanner.vue?vue&type=style&index=0&id=121414e4&scoped=true&lang=css"

import exportComponent from "/Users/farhad/Hemsidan/fartow-se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121414e4"]])

export default __exports__